export function V2Checkbox({
  checked,
  onChange,
  disabled,
  isHeader = false,
  indeterminate = false,
}) {
  const on = checked || indeterminate;
  return (
    <label className="relative inline-flex items-center justify-center cursor-pointer p-0.5 select-none shrink-0">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="sr-only peer"
      />
      <div
        className={`w-4 h-4 rounded-[4px] border transition-all flex items-center justify-center ${
          on
            ? 'bg-[#2E7D32] border-[#2E7D32]'
            : isHeader
              ? 'border-[#CBD5E1] bg-white'
              : 'border-[#CCCCCC] bg-white peer-hover:border-[#2E7D32]'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {indeterminate && !checked ? (
          <svg
            className="w-3 h-3 text-white stroke-[3.5]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" d="M6 12h12" />
          </svg>
        ) : checked ? (
          <svg
            className="w-3 h-3 text-white stroke-[3.5]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        ) : null}
      </div>
    </label>
  );
}
